import { draftJsToText } from 'my-core/editor-utils';

import InputBase from '@mui/material/InputBase';

export default function EditorMobile(props) {
  const { onChange, placeholder, value = null, ...rest } = props;

  function handleChange(e) {
    onChange(e.target.value);
  }

  const textValue = typeof value === 'object' ? draftJsToText(value) : value;

  return (
    <InputBase
      multiline
      onChange={handleChange}
      placeholder={placeholder}
      sx={{ typography: 'body2' }}
      value={textValue}
      {...rest}
    />
  );
}
